import requestHandler from '@/utils/requestHandler'
import HTTP from '@/utils/http'

export default {
  namespaced: true,

  state: {
    franchiseStoreGroupList: []
  },

  getters: {
    FranchiseStoreGroupList: (state) => state.franchiseStoreGroupList
  },

  actions: {
    async getStoreGroupFranchiseList({ commit }) {
      const results = await requestHandler({
        title: 'getStoreGroupFranchiseList',
        methodName: 'getStoreGroupFranchiseList',
        method: () => {
          return HTTP.get('Integration/franchise/config/storegroup/all')
        },
        success: result => result
      })
      return results
    },
    async getStoreGroupFranchiseListWithName({ commit }, payload) {
      const results = await requestHandler({
        title: 'getStoreGroupFranchiseListWithName',
        methodName: 'getStoreGroupFranchiseListWithName',
        method: () => {
          return HTTP.get('Integration/franchise/config/storegroup/all/hassettings', {
            params: { ...payload }
          })
        },
        success: async (result) => {
          commit("SET_FRANCHISE_STORE_GROUP_LIST", result.data)
          return result
        }
      })
      return results
    },
    async setStoreGroupFranchiseConfig({ commit }, payload) {
      const results = await requestHandler({
        title: 'setStoreGroupFranchiseConfig',
        methodName: 'setStoreGroupFranchiseConfig',
        method: () => {
          return HTTP.post('Integration/franchise/config/save', payload)
        },
        success: result => result
      })
      return results
    }
  },
  mutations: {
    SET_FRANCHISE_STORE_GROUP_LIST (state, data) {
      state.franchiseStoreGroupList = data.items
    }
  }
}
